<template>
    <page :tabs="tabs">
        <admin-app-access-level />
    </page>
</template>

<script>
    import { mapGetters } from 'vuex';
    import page from '../../generic/page/page.vue';

    import AdminAppAccessLevel from './admin-app-access-level.vue';

    export default {
        components: {
            page,
            AdminAppAccessLevel,
        },
        name: 'AdminAppStatistics',
        data() {
            return {
                busy: false,
                tabs: [
                    {
                        title: 'Lodgix Admin App',
                        active: true,
                    },
                ],
            };
        },
        computed: {
            ...mapGetters('header', ['userCurrencySymbol']),

        },
        mounted() {
            //
        },
        methods: {
            //
        },
    };
</script>

<style lang="scss" scoped>
    .subscribers-list-wrapper {
        top: 40px;
    }
    .subscribers-wrapper {
        min-width: 300px;
    }
</style>
